import { AxiosPromise } from 'axios'

import api from '@config/api'

interface IUploadData {
  file?: any
  id: any
}

export function getParamsReabCronograma(empresaId: any): AxiosPromise {
  const url = 'v1/ParametroReab/Cronograma/' + empresaId

  return api.get(url)
}

export function putParamsReabCronograma(obj: any): AxiosPromise {
  const url = 'v1/ParametroReab/Cronograma'

  return api.put(url, obj, {})
}

export function getParamsReabCronogramaHistoric(empresaId: any): AxiosPromise {
  const url = 'v1/ParametroReab/Cronograma/Historico/' + empresaId

  return api.get(url)
}

export function getParamsReabTypeOfVeichule(id: any): AxiosPromise {
  const url = 'v1/ParametroReab/TipoVeiculo?empresaId=' + id

  return api.get(url)
}
export function getParamsReabTypeOfVeichuleHistoric(id: any): AxiosPromise {
  const url = 'v1/ParametroReab/TipoVeiculo/Historico?empresaId=' + id

  return api.get(url)
}

export function deleteParamsReabTypeOfVeichule(id: any): AxiosPromise {
  const url = 'v1/ParametroReab/TipoVeiculo/' + id

  return api.delete(url)
}

export function putParamsReabTypeOfVeichule(obj: any): AxiosPromise {
  const url = 'v1/ParametroReab/TipoVeiculo'

  return api.put(url, obj, {})
}

export function postParamsReabTypeOfVeichule(obj: any): AxiosPromise {
  const url = 'v1/ParametroReab/TipoVeiculo'

  return api.post(url, obj, {})
}

export function uploadTypeOfVeichule({
  file: fileUpload,
  id
}: IUploadData): AxiosPromise {
  const formData = new FormData()
  formData.append('file', fileUpload)
  return api.post('v1/ParametroReab/TipoVeiculo/Arquivo/' + id, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// ROTAS

export function getParamsReabRoute(id: any): AxiosPromise {
  const url = 'v1/ParametroReab/Rotas/' + id

  return api.get(url)
}
export function getParamsReabRouteHistoric(id: any): AxiosPromise {
  const url = 'v1/ParametroReab/Rotas/Historico/' + id

  return api.get(url)
}

export function deleteParamsRoute(id: any): AxiosPromise {
  const url = 'v1/ParametroReab/Rotas/' + id

  return api.delete(url)
}

export function putParamsRoute(obj: any): AxiosPromise {
  const url = 'v1/ParametroReab/Rotas'

  return api.put(url, obj, {})
}

export function postParamsReabRoute(obj: any): AxiosPromise {
  const url = 'v1/ParametroReab/TipoVeiculo'

  return api.post(url, obj, {})
}

export default {
  getParamsReabCronograma,
  getParamsReabCronogramaHistoric,
  putParamsReabCronograma,
  getParamsReabTypeOfVeichule,
  postParamsReabTypeOfVeichule,
  putParamsReabTypeOfVeichule,
  deleteParamsReabTypeOfVeichule,
  uploadTypeOfVeichule,
  getParamsReabTypeOfVeichuleHistoric,
  getParamsReabRoute,
  getParamsReabRouteHistoric,
  deleteParamsRoute,
  putParamsRoute,
  postParamsReabRoute
}
